import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

@Pipe({ name: 'cellularDeviceStatusFormat' })
export class CellularDeviceStatusFormatPipe implements PipeTransform {
    transform(status: any, dateFormat: string): string {
        if (!status || _.isEqual(status, {})) {
            return 'n/a';
        }

        let state = '';
        if (status.isConnected) {
            state = status.isActive ? 'Active Online' : 'Inactive Online';
        } else {
            state = status.isActive ? 'Active Offline' : 'Inactive Offline';
        }

        const formatedTimestamp = status.timeStamp
            ? moment(status.timeStamp).format(dateFormat)
            : '';

        return `${state}  ${formatedTimestamp}`;
    }
}